import {
  redirect,
  type ActionFunctionArgs,
  type LoaderFunctionArgs,
  Form,
  useLoaderData,
} from 'react-router'
import { Button } from '#app/components/ui/button.tsx'
import { localeCookie } from '#app/middleware/i18next.ts'
import { requireControlsToBeEnabled } from '#app/utils/controls.server.ts'

export async function loader({ request }: LoaderFunctionArgs) {
  requireControlsToBeEnabled()

  const cookieHeader = request.headers.get('cookie')
  const locale = await localeCookie.parse(cookieHeader)

  return { locale }
}

export async function action({ request }: ActionFunctionArgs) {
  const formData = await request.formData()
  const intent = formData.get('intent')

  switch (intent) {
    case 'deleteLocaleCookie': {
      return redirect('/controls', {
        headers: {
          'set-cookie': await localeCookie.serialize('', {
            expires: new Date(),
          }),
        },
      })
    }
    default: {
      throw new Response(`${intent} intent is not supported`, {
        status: 400,
      })
    }
  }
}

export default function ControlsRoute() {
  const data = useLoaderData<typeof loader>()
  const { locale } = data

  return (
    <main id="main-content">
      <div>
        <strong>Locale:</strong> {locale}
        <Form className="inline pl-2" method="POST">
          <Button
            variant="link"
            type="submit"
            name="intent"
            value="deleteLocaleCookie"
          >
            Delete locale cookie
          </Button>
        </Form>
      </div>
    </main>
  )
}
